import React, { useState, useEffect } from "react";
import { Row, Col, Card, CardBody, Spinner } from "reactstrap";
// import rButton from "reactstrap/button";

import {
  deleteRequest,
  putRequest,
  postRequest,
  putRequestForm,
  RBButton,
  deleteConfirmationWords,
} from "components/Common/Utils";
import { useHistory, useParams, useLocation } from "react-router-dom";
import { Link, NavLink } from "react-router-dom";
import moment from "moment";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { format } from "date-fns";
// import StarComponent from "./StarComponent";

import Lightbox from "react-image-lightbox";

import GridList from "@material-ui/core/GridList";
import GridListTile from "@material-ui/core/GridListTile";
import GridListTileBar from "@material-ui/core/GridListTileBar";

import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Avatar,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";

import LocationPicker from "react-location-picker";
// import DayTimePicker from "./DayTimePicker";

import { makeStyles } from "@material-ui/core/styles";
import { ToastContainer, toast } from "react-toastify";

import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogActions from "@material-ui/core/DialogActions";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";

import "./CustomCard.css";


export default function Shopdetails() {
  const location = useLocation();
  const state = location.state?.row;
  const [userAllDetails, setuserAllDetails] = useState(state);
  const [loader, setLoader] = useState(false);
  const [imageLB, setImage] = React.useState("");
  const [ShopeInfo, setShopeInfo] = useState([]);

  const [openLightbox, setOpenLightBox] = React.useState(false);

  const useStyles = makeStyles({
    tableHeader: {
      color: "#ffffff", // Use your preferred color
      backgroundColor: "#3f51b5", // Header background color
      fontWeight: "bold",
    },
    descriptionText: {
      fontSize: "0.8rem",
    },
    deleteIcon: {
      color: "red",
    },
    roundImage: {
      borderRadius: "50%",
      width: "75px",
      height: "75px",
    },
    roundImageSm: {
      borderRadius: "50%",
    },

    gridList: {
      width: "100%",
    },
    icon: {
      color: "rgba(255, 55, 25, 0.54)",
    },
  });

  const formatDate = (dateString) => {
    const options = { year: "numeric", month: "long", day: "numeric" };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const showLightBox = (image) => {
    setImage(image);
    setOpenLightBox(true);
  };

  const {
    first_name,
    last_name,
    image,
    country_code,
    gender,
    country,
    nationality,
    email,
    mobile,
    dob,
    createdAt,
    address,
  } = userAllDetails;

  console.log({ state });



  const ShopesDetails = async () => {
    try {
      setLoader(true);
  
      // Construct payload
      const payload = {
    
        shopId: state?._id,
     
    
      };
  
     
  
      // Make API request
      const response = await postRequest('shop/detail-admin', payload);
  
      // Handle response data
      const data = response?.data || [];

      setShopeInfo(data);

    } catch (error) {
      console.error('Error fetching Shopes list:', error);
      // Optionally display error feedback to the user
    } finally {
      setLoader(false);
    }
  };


 useEffect(()=>{
  ShopesDetails()
 },[])


  return (
    <>
      <ToastContainer />
      <Row>
        <Col className="10">
          <div className="page-title-box">
            <h4>User Management</h4>
            <ol className="breadcrumb m-0">
              <li className="breadcrumb-item active">User Management</li>:{" "}
              <li className="breadcrumb-item">Shop details</li>
            </ol>
          </div>
        </Col>
        <div className="col-md-2 text-end">
          <button
            type="button"
            class="btn btn-primary btn-lg"
            onClick={() => history.back()}
          >
            <i class="fas fa-chevron-left"></i> Back
          </button>
        </div>

        {loader ? (
          <CardBody style={{ height: "100px" }}>
            <Spinner
              color="info"
              style={{
                height: "4rem",
                width: "4rem",
                position: "absolute",
                left: "50%",
              }}
            >
              Loading...
            </Spinner>
          </CardBody>
        ) : (
          <>
            <Card className="custom-card">
              <div
                className="cover-image"
                style={{ backgroundColor: "rgb(29, 155, 240)" }}
              ></div>
              <div className="profile-image">
                <img
                  src={
                    image
                      ? image
                      : `https://ui-avatars.com/api/?background=random&name=${
                        ShopeInfo?.shopName
                        }`
                  }
                  onClick={() =>
                    showLightBox(
                      image
                        ? image
                        : `https://ui-avatars.com/api/?background=random&name=${
                            ShopeInfo?.shopName
                          }`
                    )
                  }
                  alt="Image Not Available"
                />
              </div>
              <br></br>

              <div className="row my-2 py-2">
                <div
                  className="userinfo col-md-12 "
                  style={{ paddingLeft: "20px" }}
                >
                  <div className="fst">
                    {" "}
                    <h3> {ShopeInfo?.shopName} </h3>{" "}
                  </div>
                  <div className="row">
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Email: <span>{ShopeInfo?.email}</span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        mobile: <span> {ShopeInfo?.phone} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        City: <span> {ShopeInfo?.city} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Status: <span> {ShopeInfo?.shopStatus} </span>{" "}
                      </p>{" "}
                    </div>
                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        State: <span> {ShopeInfo?.state} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      {" "}
                      <p>
                        {" "}
                        Post Code: <span> {ShopeInfo?.postCode} </span>{" "}
                      </p>{" "}
                    </div>

                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Landmark
                        <span> {ShopeInfo?.landmark}</span>
                      </p>
                    </div>
                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Address Line
                        <span> {ShopeInfo?.addressLine1}</span>
                      </p>
                    </div>
                    <div className="col-md-4 fst py-1">
                      <p>
                        {" "}
                        Address Line 2
                        <span> {ShopeInfo?.addressLine2}</span>
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </Card>
         
          </>
        )}

        {openLightbox && (
          <Lightbox
            mainSrc={imageLB}
            onCloseRequest={() => setOpenLightBox(false)}
          />
        )}
      </Row>
      <ToastContainer />{" "}
    </>
  );
}
